import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralMyGames = styled.div`
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: transparent;
  .row {
    flex-direction: column;
  }
`;

export const HR = styled.hr`
  background-color: ${({ theme }) => theme.neutral.gray[700]};
  height: 2px;
  width: 96.5%;
`;

export const ContentHeaderMyGames = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const TitleMyGames = styled.p`
  font-size: 20px;
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-weight: 700;
`;

export const DateContainer = styled.div`
  margin-left: 10px;
  label {
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.neutral.gray[2200]};
  }
  input {
    font-size: 13px;
    font-weight: 400;
  }
`;

export const ContentFilters = styled.div`
  display: grid;
  grid-gap: 1em;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 1em;
  @media only screen and (min-width: 769px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftContent = styled.div`
  display: grid;
`;
export const CenterContent = styled.div`
  display: grid;
`;
export const RightContent = styled.div`
  display: grid;
  margin-left: 0.9em;
`;

export const SearchField = styled.div`
  width: 267px;
  height: 30px;
  position: relative;
  background: ${({ theme }) => theme.neutral.white};
  border-radius: 5px;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  svg {
    position: absolute;
    right: 10px;
  }
  input {
    font-size: 12px;
    font-weight: 400;
    height: 2.6em;
    outline: none;
    width: 85%;
    box-shadow: none;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: #989898;
  }
`;

export const useStyles = makeStyles(() => ({
  contentForMySpaces: {
    backgroundColor: theme.background.light,
    margin: "0",
    minHeight: "83vh",
    padding: "1em",
    width: "100%",
  },
}));
